module.exports = __webpack_public_path__ + "mo/media/emotion_mobile.37457db9.mp4";